<template>
    <div>
        <k-container class="border-b-2 border-t-2 border-gray-300">
            <div class="pt-8 pb-5 grid grid-cols-2 md:grid-cols-4 gap-4">
                <div v-for="category in categories" :key="category.title">
                    <div class="text-lg font-semibold mb-5">
                        {{category.title}}
                    </div>
                    <div v-for="(item, index) in category.items" :key="item.title" class="text-sm text-gray-700"
                         :class="[category.items.length === index + 1 ? 'mb-0': 'mb-3']">
                        <a v-if="item.external" :href="item.href">{{item.title}}</a>
                        <router-link v-else :to="item.href">{{item.title}}</router-link>
                    </div>
                </div>
                <div class="text-center">
                    <img src="/img/kilde_logo.png" style="max-width: 120px;">
                </div>
            </div>
        </k-container>
        <div class="text-center text-gray-500 text-xs py-3">
            Copyright © 2022 KILDE. All rights reserved.
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                itemsVisible: false,
                categories: []
            }
        },
        mounted() {
            this.landingUrl = process.env.VUE_APP_KILDE_LENDING_BASE_URL
            this.items = []

            this.categories = [
                {
                    title: 'Contacts',
                    items: [
                        {title: '+65 695 126 40', href: 'tel:+6569512640',  external: true},
                        {title: 'info@kilde.sg', href: 'mailto:info@kilde.sg',  external: true}
                    ]
                },
                {
                    title: 'Invest',
                    items: [
                        {title: 'How It Works', href: this.landingUrl, external: true},
                        {title: 'Fees', href: 'https://assets.website-files.com/61c1fc0c4b29a848ee7d2928/626bb4ef0c53da4e36b7060e_pricing-guide.pdf', external: true},
                        {title: 'FAQ', href: this.landingUrl + 'faq', external: true},
                        {title: 'Terms of use', href: 'https://assets.website-files.com/61c1fc0c4b29a848ee7d2928/633149af2ffcde097e5b8fba_20220815_Terms%20of%20Use.pdf', external: true},
                        {title: 'Privacy policy', href: 'https://www.kilde.sg/privacy', external: true},
                    ]
                },
                {
                    title: 'Company',
                    items: [
                        {title: 'About', href: this.landingUrl + 'about-us', external: true}
                    ]
                }
            ]

        }
    }
</script>

